import {
  COD_ORDER,
  COD_SERVER_ADDR,
  MESSAGING,
  COD_ORDER_EMAIL,
} from '../../constants/api-constants';
import httpClient from '../../utils/http-client';

const config = {
  baseURL: MESSAGING.baseUrl,
};

export const fetchCODSettings = (userId: string) => {
  return httpClient.get(
    MESSAGING.api.COD_SETTINGS.replace('$userId', userId),
    config
  );
};

export const updateCODSettings = (userId: string, params: any) => {
  return httpClient.put(
    MESSAGING.api.COD_SETTINGS.replace('$userId', userId),
    params,
    config
  );
};

export const fetchCODOrder = (token: string) => {
  return httpClient.get(COD_ORDER.replace('$token', token), {
    baseURL: COD_SERVER_ADDR,
  });
};
export const fetchCODOrderEmail = (token: string) => {
  return httpClient.get(COD_ORDER_EMAIL.replace('$token', token), {
    baseURL: COD_SERVER_ADDR,
  });
};

export const updateCODOrderStatus = (token: string, params: any) => {
  return httpClient.put(COD_ORDER.replace('$token', token), params, {
    baseURL: COD_SERVER_ADDR,
  });
};
